export default __webpack_public_path__ + "static/media/wordpress-icon.28e95274.png";